import React, { useMemo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Select } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import ExpandMore from "@mui/icons-material/ExpandMore";
const useStyles = makeStyles((theme) => ({
    formControl: {
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            marginRight: 0,
        },
        "& fieldset": {
            borderColor: theme.palette.primary.main,
            borderWidth: "2px",
        },
    },
    styledSelect: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        borderWidth: "2px",
        "& select.MuiSelect-select": {
            minWidth: theme.spacing(3),
            padding: theme.spacing(2, 3, 2, 2),
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(1, 1), // reduced padding on mobile
                textAlign: "center",
            },
        },
        "& .MuiSelect-icon": {
            color: "inherit",
            [theme.breakpoints.down("sm")]: {
                display: "none",
            },
        },
    },
    disabled: {
        borderColor: theme.palette.primary.light,
    },
}));
const QuantitySelector = ({ id, quantity, minQuantity, includeZero = false, onChange = undefined, maxQuantity = null, disabled = undefined, }) => {
    const classes = useStyles();
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const quantityList = useMemo(() => {
        // There have to be a better way to make this?
        const options = [];
        const maxVal = maxQuantity || quantity + 100;
        console.log("Max val is", minQuantity, maxVal, typeof quantity);
        for (let i = minQuantity || 1; i <= maxVal; i++) {
            options.push(i);
        }
        console.log("Max val", options);
        console.log("Quantity list", options);
        return options;
    }, [quantity, maxQuantity, minQuantity]);
    return (React.createElement(FormControl, { variant: "outlined", className: classes.formControl },
        React.createElement(Select, { native: true, value: quantity, onChange: handleChange, id: id, disabled: disabled, className: `${classes.styledSelect}`, IconComponent: ExpandMore },
            includeZero && React.createElement("option", { value: 0 }, "0"),
            quantityList.map((i) => (React.createElement("option", { key: i, value: i }, i))))));
};
export default QuantitySelector;
